import { environment } from './environment';

export { environment };
